// Results' section ids: the nav's targets and the anchors the page renders.

export const RESULTS_SECTION = {
    summary: "results-summary",
    trend: "results-trend",
    steps: "results-steps",
    step: (stepId: string) => `results-step-${stepId}`,
    timeOfDay: "results-time-of-day",
} as const;
